import { message, Modal, Table, Button } from 'antd'
import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import classes from './AdminKorisnickiPaketiProdaja.module.css'
import AuthContext from '../context/AuthProvider'

const AdminKorisnickiPaketiProdaja = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL
  const { auth } = useContext(AuthContext)
  const [allPackages, setAllPackages] = useState([])
  const [addPackagesModalOpen, setAddPackagesModalOpen] = useState(false)
  const [editPackagesModalOpen, setEditPackagesModalOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [selectedPackages, setSelectedPackages] = useState(null)
  const [refetchTrigger, setRefetchTrigger] = useState(false)

  const [packageValues, setPackageValues] = useState({
    descriptionMobile: '',
    descriptionWeb: '',
    price: '',
    dayPrice: '',
    monthPrice: '',
    discountPercentage: '',
    packageDuration: '',
  })

  useEffect(() => {
    const getAllPackages = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/get-all-package`)
        setAllPackages(response?.data)
      } catch (err) {
        console.error('Error fetching packages:', err)
      }
    }

    getAllPackages()
  }, [refetchTrigger])

  const handleAddPackages = async () => {
    try {
      await axios.post(
        `${SERVER_URL}/create-package`,
        { ...packageValues },
        {
          withCredentials: false,
          headers: { Authorization: `Bearer ${auth.accessToken}` },
        }
      )
      setRefetchTrigger((curr) => !curr)
      setAddPackagesModalOpen(false)
      message.success('Paket uspešno dodata!')
    } catch (err) {
      console.error(err?.message || err)
      message.error(err?.message || err)
    }
  }

  const handleEditPackages = async () => {
    try {
      await axios.put(
        `${SERVER_URL}/update-package/${selectedPackages._id}`,
        { ...packageValues },
        {
          withCredentials: false,
          headers: { Authorization: `Bearer ${auth.accessToken}` },
        }
      )
      setRefetchTrigger((curr) => !curr)
      setEditPackagesModalOpen(false)
      message.success('Paket uspešno izmenjen!')
    } catch (err) {
      console.error(err?.message || err)
      message.error(err?.message || err)
    }
  }

  const handleDeletePackages = async () => {
    try {
      await axios.delete(
        `${SERVER_URL}/delete-package/${selectedPackages._id}`,
        {
          withCredentials: false,
          headers: { Authorization: `Bearer ${auth.accessToken}` },
        }
      )
      setRefetchTrigger((curr) => !curr)
      setDeleteModalOpen(false)
      message.success('Paket uspešno obrisan!')
    } catch (err) {
      console.error(err?.message || err)
      message.error(err?.message || err)
    }
  }

  const columns = [
    {
      title: 'Opis Mobilni',
      dataIndex: 'descriptionMobile',
      key: 'descriptionMobile',
      ellipsis: true,
      className: 'truncate-text',
    },
    {
      title: 'Opis Web',
      dataIndex: 'descriptionWeb',
      key: 'descriptionWeb',
      ellipsis: true,
      className: 'truncate-text',
    },
    {
      title: 'Cena u Evrima',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Dnevna cena u Evrima',
      dataIndex: 'dayPrice',
      key: 'dayPrice',
    },
    {
      title: 'Mesečna cena u Evrima',
      dataIndex: 'monthPrice',
      key: 'monthPrice',
    },
    {
      title: 'Popust',
      dataIndex: 'discountPercentage',
      key: 'discountPercentage',
    },
    {
      title: 'Period u danima',
      dataIndex: 'packageDuration',
      key: 'packageDuration',
    },
    {
      title: 'Akcije',
      key: 'actions',
      render: (_, record) => (
        <span>
          <Button
            type='link'
            onClick={() => {
              setPackageValues(record)
              handleOpenEditModal(record)
            }}
          >
            Izmeni
          </Button>
          {/* <Button type='link' onClick={() => handleOpenDeleteModal(record)}>
            Obriši
          </Button> */}
        </span>
      ),
    },
  ]

  const handleOpenEditModal = (record) => {
    setSelectedPackages(record)
    setEditPackagesModalOpen(true)
  }

  const handleOpenDeleteModal = (record) => {
    setSelectedPackages(record)
    setDeleteModalOpen(true)
  }

  return (
    <div className={classes.packagesPageWrapper}>
      <div className={classes.topWrapper}>
        <h2>Svi Paketi</h2>
        <Button
          type='primary'
          onClick={() => {
            setPackageValues({
              descriptionMobile: '',
              descriptionWeb: '',
              price: '',
              dayPrice: '',
              monthPrice: '',
              discountPercentage: '',
              packageDuration: '',
            })
            setAddPackagesModalOpen(true)
          }}
        >
          Dodaj paket
        </Button>
      </div>

      <Table
        dataSource={allPackages?.allPackages || []}
        columns={columns}
        rowKey='_id'
        className={classes.packagesTable}
        pagination={false}
      />

      {/* Add Packages Modal */}
      <Modal
        title='Dodaj Paket'
        open={addPackagesModalOpen}
        onOk={handleAddPackages}
        onCancel={() => setAddPackagesModalOpen(false)}
        className={classes.packagesModal}
        okText='Dodaj'
        cancelText='Otkaži'
      >
        <div className={classes.editPackageContainer}>
          <span>Opis za mobilni</span>
          <textarea
            value={packageValues?.descriptionMobile}
            onChange={(e) =>
              setPackageValues((values) => ({
                ...values,
                descriptionMobile: e.target.value,
              }))
            }
            placeholder='Opis za mobilni'
          />
          <span>Opis za WEB</span>
          <textarea
            value={packageValues?.descriptionWeb}
            onChange={(e) =>
              setPackageValues((values) => ({
                ...values,
                descriptionWeb: e.target.value,
              }))
            }
            placeholder='Opis za WEB'
          />
          <div>
            <span>
              CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.price}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    price: e.target.value,
                  }))
                }
                placeholder='CENA'
              />
            </span>
            <span>
              DNEVNA CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.dayPrice}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    dayPrice: e.target.value,
                  }))
                }
                placeholder='DNEVNA CENA'
              />
            </span>
            <span>
              MESEČNA CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.monthPrice}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    monthPrice: e.target.value,
                  }))
                }
                placeholder='MESEČNA CENA'
              />
            </span>
          </div>
          <div>
            <span>
              POPUST:
              <input
                type='number'
                value={packageValues?.discountPercentage}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    discountPercentage: e.target.value,
                  }))
                }
                placeholder='POPUST'
              />
            </span>
            <span>
              PERIOD U DANIMA:
              <input
                value={packageValues?.packageDuration}
                type='number'
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    packageDuration: e.target.value,
                  }))
                }
                placeholder='PERIOD'
              />
            </span>
          </div>
        </div>
      </Modal>

      {/* Edit Packages Modal */}
      <Modal
        title='Izmeni Paket'
        open={editPackagesModalOpen}
        onOk={handleEditPackages}
        onCancel={() => setEditPackagesModalOpen(false)}
        className={classes.packagesModal}
        okText='Izmeni'
        cancelText='Otkaži'
      >
        <div className={classes.editPackageContainer}>
          <span>Opis za mobilni</span>

          <textarea
            value={packageValues?.descriptionMobile}
            onChange={(e) =>
              setPackageValues((values) => ({
                ...values,
                descriptionMobile: e.target.value,
              }))
            }
            placeholder='Opis za mobilni'
          />
          <span>Opis za WEB</span>

          <textarea
            value={packageValues?.descriptionWeb}
            onChange={(e) =>
              setPackageValues((values) => ({
                ...values,
                descriptionWeb: e.target.value,
              }))
            }
            placeholder='Opis za WEB'
          />
          <div>
            <span>
              CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.price}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    price: e.target.value,
                  }))
                }
                placeholder='CENA'
              />
            </span>
            <span>
              DNEVNA CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.dayPrice}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    dayPrice: e.target.value,
                  }))
                }
                placeholder='DNEVNA CENA'
              />
            </span>
            <span>
              MESEČNA CENA U EVRIMA:
              <input
                type='number'
                value={packageValues?.monthPrice}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    monthPrice: e.target.value,
                  }))
                }
                placeholder='MESEČNA CENA'
              />
            </span>
          </div>
          <div>
            <span>
              POPUST:
              <input
                type='number'
                value={packageValues?.discountPercentage}
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    discountPercentage: e.target.value,
                  }))
                }
                placeholder='POPUST'
              />
            </span>
            <span>
              PERIOD U DANIMA:
              <input
                value={packageValues?.packageDuration}
                type='number'
                onChange={(e) =>
                  setPackageValues((values) => ({
                    ...values,
                    packageDuration: e.target.value,
                  }))
                }
                placeholder='PERIOD'
              />
            </span>
          </div>
        </div>
      </Modal>

      {/* Delete Packages Modal */}
      <Modal
        title='Obriši Paket'
        open={deleteModalOpen}
        onOk={handleDeletePackages}
        onCancel={() => setDeleteModalOpen(false)}
        okText='Obriši'
        cancelText='Otkaži'
      >
        Da li ste sigurni da želite da obrišete ovaj paket?
      </Modal>
    </div>
  )
}

export default AdminKorisnickiPaketiProdaja
